import { CabecalhoPagina } from '@/ui/patterns/cabecalho-pagina';

import { FormularioEnvio } from './formulario-envio';
import { HistoricoLotes } from './historico-lotes';

export function PaginaImportacao() {
  return (
    <div className="grid gap-6">
      <CabecalhoPagina
        titulo="Importar notas"
        descricao="Envie XMLs, ZIPs ou o relatório da SEFAZ. Notas repetidas são reconhecidas pela chave e não duplicam."
      />
      <div className="grid items-start gap-6 xl:grid-cols-[minmax(0,1fr)_22rem]">
        <FormularioEnvio />
        <HistoricoLotes />
      </div>
    </div>
  );
}
